import * as React from 'react';
import styles from './hero.module.css';
import { useNavigate } from 'react-router-dom'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import heroImg from '../../assets/Hero.png'; // Adjust the path as necessary


const Hero: React.FC = () => {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    navigate('/courses');
  };

  const handleKnowMoreClick = () => {
    navigate('/about');
  };

  return (
    <section className={styles.hero}>
      <div className={styles.content}>
        <h1 className={styles.title}>Master Tech Skills with <br /> <span>CyberINN</span></h1>
        <p className={styles.subtitle}>
          Learn from industry experts and accelerate your career in Cybersecurity, 
          Game Development, Web Development and AI.
        </p>
        <div className={styles.buttonGroup}>
          <button 
            onClick={handleExploreClick}
            className={styles.exploreButton}
          >
            Explore Courses
          </button>
          <button 
            onClick={handleKnowMoreClick}
            className={styles.knowMoreButton}
          >
            Know More <FontAwesomeIcon icon={faArrowRight} className={styles.icon} />
          </button>
        </div>
      </div>
      
      <div className={styles.imageContainer}>
        <img 
          src={heroImg} 
          alt="Learn Cybersecurity, Game Development, Web Development and AI"
          className={styles.heroImage}
        />
      </div>
    </section>
  );
};

export default Hero;